import { Grid, TextField, Typography } from '@mui/material';
import CustomSelect from 'components/CustomSelect/customSelect';
import React, { useState } from 'react';
import {
  Control,
  Controller,
  FormState,
  UseFormHandleSubmit,
  UseFormTrigger,
  UseFormWatch,
} from 'react-hook-form';
import { ClientFilterType } from 'types';

interface ClientFilterFormProps {
  control: Control<ClientFilterType, any>;
  handleSubmit: UseFormHandleSubmit<ClientFilterType, undefined>;
  formState: FormState<ClientFilterType>;
  onSubmit: (data: ClientFilterType) => void;
  watch: UseFormWatch<ClientFilterType>;
  trigger: UseFormTrigger<ClientFilterType>;
  setParams: any;
}

export const PositionFilterForm: React.FC<ClientFilterFormProps> = ({
  control,
  handleSubmit,
  formState: { errors },
  onSubmit,
  watch,
}) => {
  const currentDate = new Date();
  const day = String(currentDate.getDate()).padStart(2, '0');
  const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = currentDate.getFullYear();
  const [fromMaxDate, setFromMaxDate] = useState<string | null>(null);
  const [toMaxDate, setToMaxDate] = useState<string | null>(null);

  return (
    <form className='private-form clientfilter-form' onSubmit={handleSubmit(onSubmit)}>
      <Grid container>
        <Grid item md={12} sm={12} xs={12} sx={{ width: '100%' }}>
          <Grid container sx={{ width: '100%' }}>
            <Grid item md={12} sm={12} xs={12} sx={{ width: '100%' }}>
              <Typography component={'div'} className='custom-field' sx={{ width: '100%' }}>
                <Typography component={'p'}>From Date</Typography>
                <Controller
                  control={control}
                  defaultValue={''}
                  name='from'
                  render={({ field: { onChange, value, name } }) => {
                    return (
                      <TextField
                        id='date'
                        type='date'
                        name={name}
                        value={value ? value : null}
                        className='clientfilter-time-from-to'
                        onChange={(e) => {
                          setFromMaxDate(e.target.value);
                          onChange(e);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          inputProps: { max: toMaxDate || `${year}-${month}-${day}` },
                        }}
                      />
                    );
                  }}
                />
              </Typography>
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <Typography component={'div'} className='custom-field'>
                <Typography component={'p'}>To Date</Typography>
                <Controller
                  control={control}
                  defaultValue={''}
                  name='to'
                  render={({ field: { onChange, value, name } }) => {
                    return (
                      <TextField
                        id='date'
                        type='date'
                        name={name}
                        value={value ? value : null}
                        className='clientfilter-time-from-to'
                        defaultValue={value}
                        onChange={(e) => {
                          setToMaxDate(e.target.value);
                          onChange(e);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          inputProps: { min: fromMaxDate, max: `${year}-${month}-${day}` },
                        }}
                      />
                    );
                  }}
                />
              </Typography>
            </Grid>
                <Grid item md={12} sm={12} xs={12}>
                  <Typography component={'div'} className='custom-field'>
                    <Typography component={'p'}>Status</Typography>
                    <Controller
                      control={control}
                      defaultValue={''}
                      name='status'
                      render={({ field: { onChange, value, name } }) => {
                        return (
                          <CustomSelect
                            labelKey={'label'}
                            valueKey={'value'}
                            isClearable={false}
                            options={[
                              { label: 'Active', value: true },
                              { label: 'Inactive', value: false },
                            ]}
                            name={name}
                            value={value ? value : null}
                            onChange={(e) => {
                              onChange(e);
                            }}
                            placeHolder='Select Status'
                            error={errors.status?.message}
                          />
                        );
                      }}
                    />
                  </Typography>
                </Grid>
          </Grid>
        </Grid>
      </Grid>

      <button
        type='submit'
        className='clientfilter-form-btn'
        style={{
          ...(!(
            watch('from') ||
            watch('status') ||
            watch('to')
          )
            ? { opacity: '0.5', cursor: 'not-allowed' }
            : {}),
        }}>
        Apply
      </button>
    </form>
  );
};
